export function ParallaxBg({ className = 'menu-bg' }: { className?: string }) {
  return <div className={className} />;
}
